import { render, staticRenderFns } from "./SignUpRoles.vue?vue&type=template&id=5e00d110"
import script from "./SignUpRoles.vue?vue&type=script&lang=ts"
export * from "./SignUpRoles.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5e00d110')) {
      api.createRecord('5e00d110', component.options)
    } else {
      api.reload('5e00d110', component.options)
    }
    module.hot.accept("./SignUpRoles.vue?vue&type=template&id=5e00d110", function () {
      api.rerender('5e00d110', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/auth/SignUpRoles.vue"
export default component.exports